@import "src/style/lib";

.select-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  min-width: 17.5rem;
  width: min(80vw, 40rem);
  text-decoration: none;
  .input-query {
    height: 2.8rem;
    line-height: 2.8rem;
    border-radius: 1.4rem;
    padding-left: 1rem;
  }
}

.select-box-overlay .input-query {
  min-width: auto;
  max-width: 100%;
  width: 100%;
}

.selected-value-display {
  display: flex;
  position: relative;
  width: 100%;
  height: 2.8rem;
  line-height: 2.8rem;
  text-align: left;
  white-space: nowrap;
  border-radius: 1.4rem;
  padding-left: 1rem;
  background-color: #fff;
  color: #000;
}

.selected-value-display-image {
  flex: 0 0 2rem;
  height: 2rem;
  width: 2rem;
  margin: 0.4rem;
}

//TODO: preserve the unique name part (VIKEN etc)
.selected-value-display-text {
  flex: 0 1 100%;
  padding-right: 3.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.select-box-overlay {
  .select-box-result {
    background: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    color: $bjelin-dark-grey;
    text-align: left;
    text-shadow: none;
    user-select: none;

    .select-box-item {
      position: relative;
      display: flex;
      justify-content: flex-start;
      padding: 0.5rem 1rem;
      overflow: hidden;
      text-shadow: none;
      h4 {
        text-shadow: none;
      }

      &.compact {
        padding: 0.3rem 1rem;
      }
    }
  }
}

.select-box-item {
  height: 4.5rem;

  &.compact {
    height: auto;
    padding: 0.3rem 1rem;
  }
}
